import { useRouteMatchParam } from '@/hooks';
import { Card, Empty, Layout } from 'antd';
import logo from '@/assets/images/Logo_Footer.png';
import './styles.less';
import { useWorkOrdersStickerByToken } from '@/core/domain/workorder/QRCode/QRCode.hooks';
import TableServicesPreviouslyPerformed from '@/components/Movements/WorkOrders/Details/WorkOrderFooter/WorkOrderReviewEtiquetteButton/WorkOrderReviewEtiquetteModal/TableServicesPreviouslyPerformed';

export default function PublicWorkOrderReviewEtiquette() {
  const guid = useRouteMatchParam('guid');

  const workOrdersStickerByToken = useWorkOrdersStickerByToken(guid);

  const [firstItem, ...restItems] = workOrdersStickerByToken.data ?? [];

  const isValidParams = !!guid;

  if (!isValidParams) {
    return <Empty description="Parâmetros inválidos na URL" />;
  }

  return (
    <>
      <Layout.Header className="app-header" style={{ textAlign: 'center' }}>
        <img className="image" src={logo} alt="logo" style={{ height: 25 }} />
      </Layout.Header>

      <div className="review-etiquette-container">
        <Card className="review-etiquette-card" bordered={false}>
          <div className="review-etiquette-table-section">
            <big style={{ fontWeight: 700 }}>Itens do orçamento</big>

            <TableServicesPreviouslyPerformed
              restItems={[firstItem]}
              loading={workOrdersStickerByToken.isLoading}
              isFetching={workOrdersStickerByToken.isFetching}
              hasNextPage={false}
            />
          </div>

          <div className="review-etiquette-table-section">
            <big style={{ fontWeight: 700 }}>Serviços anteriores</big>

            <TableServicesPreviouslyPerformed
              restItems={restItems}
              loading={workOrdersStickerByToken.isLoading}
              isFetching={workOrdersStickerByToken.isFetching}
            />
          </div>
        </Card>
      </div>
    </>
  );
}
